export const PHONE_VERIFICATION_CODE_REGEX = /^\d{6}$/;
